<div class="modal">
	<div class="modal-content">
		<div class="modal-header">
			<h2 i18n="@@signup.log_in">Log In</h2>
			<span class="close" (click)="closeLogin()">&times;</span>
		</div>
		<div class="modal-body">
			<form [formGroup]="signinForm" (ngSubmit)="onSubmit()">				
				<div class="d-flex flex-column">
					<fieldset class="" [ngClass]="{'has-error': (isSubmitted || signinForm.get('email')?.dirty) && signinForm.get('email')?.errors}">
						<label for="email" i18n="@@singup.email">Email</label>
						<input formControlName="email" type="email" id="email" required />
						<span class="field-error" *ngIf="signinForm.get('email')?.errors?.required" i18n="@@error.required.email">Email is required</span>
						<span class="field-error" *ngIf="signinForm.get('email')?.errors?.email" i18n="@@error.valid_email">Please enter valid email address</span>
						<span class="field-error" *ngIf="signinForm.get('email')?.errors?.serverError">{{ signinForm.get('email').errors?.serverError }}</span>
					</fieldset>

					<fieldset class="" [ngClass]="{'has-error': (isSubmitted || signinForm.get('password')?.dirty) && signinForm.get('password')?.errors}">
						<label for="password" i18n="@@singup.password">Password</label>
						<input formControlName="password" type="password" id="password" required />
						<span class="field-error" *ngIf="signinForm.get('password')?.errors?.required" i18n="@@error.required.password">Password is required</span>
						<span class="field-error" *ngIf="signinForm.get('password')?.errors?.minlength" i18n="@@error.confirm_password_same_new_password">Password must be at least 6 characters long</span>
					</fieldset>
				</div>

				<div class="form-actions">
					<button type="submit" class="signUpBtn btn btn-primary" i18n="@@signup.log_in">Log In</button>
				</div>
				<div class="form-actions">
					<button type="button" class="btn bg-white text-dark border" (click)="continueAsGuest()" i18n="@@signup.continue_as_guest">Continue As Guest</button>
				</div>
			</form>

			<div class="anotherVarContainer pt-4">
				<div class="line"></div>
				<span i18n="@@signup.don_t_have_account">Don’t have an account?</span>
				<div class="line"></div>
			</div>

			<a class="logInBtn" (click)="openSignUpModal()" i18n="@@signup.signup">Sign Up</a>
		</div>
	</div>
</div>